import { combineReducers } from "redux";
export const types = {
  SET_SUBJECT: "TOCOLLAGETOOL/SET_SUBJECT",
  SET_ERROR_TIP_VISIBLE: "TOCOLLAGETOOL/SET_ERROR_TIP_VISIBLE",
  SET_SEARCH_VISIBLE: "TOCOLLAGETOOL/SET_SEARCH_VISIBLE",
  SET_SCORE_CONDITON: "TOCOLLAGETOOL/SET_SCORE_CONDITON",
  SET_SUBJECT_SCORE: "TOCOLLAGETOOL/SET_SUBJECT_SCORE",
  SET_PRE_SUBJECT_SCORE: "TOCOLLAGETOOL/SET_PRE_SUBJECT_SCORE",
  SET_TOTAL_SCORE: "TOCOLLAGETOOL/SET_TOTAL_SCORE",
  SET_CONFIRM_VISIBLE: "TOCOLLAGETOOL/SET_CONFIRM_VISIBLE",
  SET_TIME: "TOCOLLAGETOOL/SET_TIME",
  SET_TIMES: "TOCOLLAGETOOL/SET_TIMES",
  SET_RELEASE: "TOCOLLAGETOOL/SET_RELEASE",
  SET_MAJOR_CONDITION: "TOCOLLAGETOOL/SET_MAJOR_CONDITION",
  SET_REGULAR_HOT_MAJOR: "TOCOLLAGETOOL/SET_REGULAR_HOT_MAJOR",
  SET_JUNIOR_HOT_MAJOR: "TOCOLLAGETOOL/SET_JUNIOR_HOT_MAJOR",
  SET_TOCOLLAGETOOL_INFO_VISIBLE:
    "TOCOLLAGETOOL/SET_TOCOLLAGETOOL_INFO_VISIBLE",
};
const initialState = {
  wholeSubject: {
    政: "政治",
    史: "历史",
    地: "地理",
    物: "物理",
    化: "化学",
    生: "生物",
    技: "技术",
  },
  maxScore: {
    语文: 150,
    数学: 150,
    外语: 150,
    政治: 100,
    历史: 100,
    地理: 100,
    物理: 100,
    化学: 100,
    生物: 100,
    技术: 100,
  },
  subjectScore: {
    语文: "",
    数学: "",
    外语: "",
    政治: "",
    历史: "",
    地理: "",
    物理: "",
    化学: "",
    生物: "",
    技术: "",
  },
  preSubjectScore: {
    语文: "",
    数学: "",
    外语: "",
    政治: "",
    历史: "",
    地理: "",
    物理: "",
    化学: "",
    生物: "",
    技术: "",
  },
  times: 0,
  release: 0,
  totalScore: "",
  subjectCondition: [],
  scoreCondition: [],
  majorCondition: [],
  hotRegularMajor: [],
  hotJuniorMajor: [],
  uiState: {
    errorTipVisible: false,
    errorTip: "",
    statInfoVisible: false,
    confirmVisible: false,
    searchVisible: true,
    time: 5,
    infoVisible: false,
    info: "<p>位次、学费、招生计划等数据，应有尽有，数据量较大。</p><p>请使用订购的手机号+密码，登录浙考之家电脑网页版（zhekaozhijia.com，密码不记得，可以点击右下角我的-密码设置，重新设置）。</p><p>底部每日高升--志愿智能助手（输入选科、专业后的结果页右上角）下载导出即可。</p>",
  },
};

export const actions = {
  //设置信息的显示和关闭
  setInfoVisible: (infoVisible) => {
    return {
      type: types.SET_TOCOLLAGETOOL_INFO_VISIBLE,
      infoVisible,
    };
  },
  //设置志愿填报的选考科目的条件
  setSubjectCondition: (subjectCondition) => {
    return {
      type: types.SET_SUBJECT,
      subjectCondition,
    };
  },
  //设置是否显示错误提示
  setErrorTip: (errorTipVisible, errorTip) => {
    return {
      type: types.SET_ERROR_TIP_VISIBLE,
      errorTipVisible,
      errorTip,
    };
  },
  //设置分数条件
  setScoreCondition: (scoreCondition) => {
    return {
      type: types.SET_SCORE_CONDITON,
      scoreCondition,
    };
  },
  //设置学科分数
  setSubjectScore: (subjectScore) => {
    return {
      type: types.SET_SUBJECT_SCORE,
      subjectScore,
    };
  },
  //设置学科分数
  setPreSubjectScore: (preSubjectScore) => {
    return {
      type: types.SET_PRE_SUBJECT_SCORE,
      preSubjectScore,
    };
  },
  //设置总分
  setTotalScore: (totalScore) => {
    return {
      type: types.SET_TOTAL_SCORE,
      totalScore,
    };
  },
  //设置志愿填报的确认框是否显示和关闭
  setConfirmVisible: (confirmVisible) => {
    return {
      type: types.SET_CONFIRM_VISIBLE,
      confirmVisible,
    };
  },
  //设置确认按钮倒计时
  setTime: (time) => {
    return {
      type: types.SET_TIME,
      time,
    };
  },
  //设置用户还可以使用的次数
  setTimes: (times) => {
    return {
      type: types.SET_TIMES,
      times,
    };
  },
  //设置用户文案提示模式
  setRelease: (release) => {
    return {
      type: types.SET_RELEASE,
      release,
    };
  },
  // 设置专业条件
  setMajorCondition: (majorCondition) => {
    return {
      type: types.SET_MAJOR_CONDITION,
      majorCondition,
    };
  },
  //设置搜索框显示和隐藏
  setSearchVisible: (searchVisible) => {
    return {
      type: types.SET_SEARCH_VISIBLE,
      searchVisible,
    };
  },
  //设置专科热门专业
  setHotJuniorMajor: (hotJuniorMajor) => {
    return {
      type: types.SET_JUNIOR_HOT_MAJOR,
      hotJuniorMajor,
    };
  },

  //设置本科热门专业
  setHotRegularMajor: (hotRegularMajor) => {
    return {
      type: types.SET_REGULAR_HOT_MAJOR,
      hotRegularMajor,
    };
  },
};

//志愿智能助手
const toCollageData = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SUBJECT:
      return { ...state, subjectCondition: action.subjectCondition };
    case types.SET_SUBJECT_SCORE:
      return { ...state, subjectScore: action.subjectScore };
    case types.SET_PRE_SUBJECT_SCORE:
      return { ...state, preSubjectScore: action.preSubjectScore };
    case types.SET_TOTAL_SCORE:
      return { ...state, totalScore: action.totalScore };
    case types.SET_SCORE_CONDITON:
      return { ...state, scoreCondition: action.scoreCondition };
    case types.SET_MAJOR_CONDITION:
      return { ...state, majorCondition: action.majorCondition };
    case types.SET_TIMES:
      return { ...state, times: action.times };
    case types.SET_RELEASE:
      return { ...state, release: action.release };
    case types.SET_JUNIOR_HOT_MAJOR:
      return { ...state, hotJuniorMajor: action.hotJuniorMajor };
    case types.SET_REGULAR_HOT_MAJOR:
      return { ...state, hotRegularMajor: action.hotRegularMajor };
    default:
      return { ...state };
  }
};

// 控制志愿智能助手弹出框的显示和关闭
const toCollageUIData = (state = initialState.uiState, action) => {
  switch (action.type) {
    case types.SET_TOCOLLAGETOOL_INFO_VISIBLE:
      return {
        ...state,
        infoVisible: action.infoVisible,
      };
    case types.SET_ERROR_TIP_VISIBLE:
      return {
        ...state,
        errorTipVisible: action.errorTipVisible,
        errorTip: action.errorTip,
      };
    case types.SET_CONFIRM_VISIBLE:
      return {
        ...state,
        confirmVisible: action.confirmVisible,
      };
    case types.SET_TIME:
      return {
        ...state,
        time: action.time,
      };
    case types.SET_SEARCH_VISIBLE:
      return {
        ...state,
        searchVisible: action.searchVisible,
      };
    default:
      return { ...state };
  }
};

const reducer = combineReducers({
  toCollageData,
  toCollageUIData,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/tocollagetool.js